import React from "react"
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import BaseComponent from "../../../base-component";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {handleApiResponse} from "../../../../crud-actions";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";

class Complete extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            successModal: false,
            submitModal: false
        }
    }

    toggleSubmitModal = () => {
        this.setState({ submitModal: !this.state.submitModal });
        document.activeElement.blur();
    };

    sendForm = (values, form) => {
        let promise = this.props.assignmentAction('api/v1', this.props.assignment.id, { execute: 'submit_form', data: values.data });
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.setState({...this.state, successModal: true});
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.personal_forms.message.submit.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, contentUnit, assignment, isComplete } = this.props;
        const disableSubmit = !(values.data.exclusivity && values.data.correctness);

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <p><FormattedMessage id='app.personal_forms.thanks'/></p>
                    <p><FormattedMessage id='app.personal_forms.changes'/></p>
                    <hr/>
                    <button type='button' className='btn btn-secondary' onClick={() => { this.props.setPage(1) }}>{intl.formatMessage({id: 'app.personal_forms.buttons.review'})}</button>
                </div>
            </form>
        );
    }

}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 7 } };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(Complete));
